import React, { useEffect, useRef, useState } from 'react'
import Img from 'gatsby-image'
import styled, { css } from 'styled-components'
import Container from './Container'
import { FullAbsolute } from '../styles/Utils'
import media from 'css-in-js-media'
import Section from './Section'
import ReactPlayer from 'react-player/lazy'
import PlayIcon from '../svg/play.svg'


const PlayerWrapper = styled.div`
    ${FullAbsolute}
    z-index: 10;
    opacity: 0;
    transition: 0.2s opacity ease-out;
    pointer-events: none;
`

const Inner = styled.div`
    position: relative;
`

const VideoSection = styled(Section)`
    ${(props) =>
        props.isActive &&
        css`
            ${PlayerWrapper} {
                opacity: 1;
                pointer-events: all;
            }
        `}
    ${Container} {
        ${media('<desktop')} {
            padding-right: 0;
            padding-left: 0;
        }
    }
`

const PlayButton = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    transition: 0.2s transform ease-out;
`

const ImageWrap = styled.div`
    cursor: pointer;

    :after {
        content: '';
        ${FullAbsolute};
        z-index: 0;
        background: rgba(0, 0, 0, 0.2);
        transition: 0.2s background-color ease-out;
    }

    :hover {
        ${PlayButton} {
            transform: scale(1.04) translate(-50%, -50%);
        }

        :after {
            background-color: rgba(0, 0, 0, 0.4);
        }
    }
`

const Video: React.FC<{
    data: object
}> = ({ data }) => {
    const [isActive, setActive] = useState(false)
    const videoPlayerRef = useRef(null)

    useEffect(() => {
        if (isActive) {
            videoPlayerRef.current.player.player.player.playVideo();
        }
    }, [isActive])

    return (
        <>
            <VideoSection isActive={isActive}>
                <Container>
                    <Inner>
                        <ImageWrap
                            onClick={() => {
                                setActive(true)
                            }}
                        >
                            <Img fluid={data.placeholderImage.fluid} alt="" />
                            <PlayButton>
                                <PlayIcon/>
                            </PlayButton>
                        </ImageWrap>

                        <PlayerWrapper>
                            <ReactPlayer
                                url={data.youtubeUrl}
                                className="react-player"
                                width="100%"
                                height="100%"
                                ref={videoPlayerRef}
                            />
                        </PlayerWrapper>
                    </Inner>
                </Container>
            </VideoSection>
        </>
    )
}

export default Video
